/*
 *		Copyright (c) 2011-2018 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Translate', ['pascalprecht.translate', 'access.Config'])
    .run(['$translate', '$document', function($translate, $document) {
        const locale = $document.find('html').attr('lang');

        $translate.use(locale);
    }]);
